<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header py-4">
          <div class="row align-items-center">
            <div class="col-8 font-size-16">({{total}}) Squads cadastrados</div>
            <div class="col-3">
              <input
                type="text"
                class="form-control form-control-sm"
                v-model="searchQuery"
                placeholder="Procurar..."
              />
            </div>
            <div class="col-1">
              <button
                type="button"
                class="btn btn-sm btn-success"
                @click="onHandleEdit(false)"
              >Criar</button>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-striped mb-0 table-bordered">
              <thead>
                <tr>
                  <th>Nome / descrição</th>
                  <th>Grupo</th>
                  <th>Pessoas no grupo</th>
                  <th width="250">Propriedades</th>
                  <th width="40">-</th>
                  <th width="40">-</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(squad, index) in paginatedFilteredItems" v-bind:key="index">
                  <td>
                    {{squad.name}}
                    <br />
                    {{squad.description}}
                  </td>
                  <td>{{squad.team.name}}</td>
                  <td>
                    <div class="team">
                      <app-avatar-admin
                        v-for="(userTeam, index2) in squad.team.users[0]"
                        v-bind:key="index2"
                        :name="userTeam.name"
                        :admin="userTeam.pivot.is_admin"
                      />
                    </div>
                  </td>
                  <td>
                    <div class="team" v-if="squad.task_model.length > 0">
                        <span class="badge rounded-pill bg-info" v-for="(p, k) in squad.task_model[0].properties"
                        v-bind:key="k">
                            {{p.propertie.name}}
                        </span>
                      
                    </div>
                    <br />
                    
                  </td>
                  <td>
                    <button
                      type="button"
                      class="btn-theme-circle bg-primary width-xs waves-effect waves-light"
                      @click="onHandleEdit(squad.id)"
                    >
                      <i class="mdi mdi-pencil-outline font-size-14 align-middle"></i>
                    </button>
                  </td>
                  <td>
                    <app-button-delete-confirm @handle="onHandleDelete(squad.id)" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="col-7">Página {{ currentPage }} de {{ totalPages }}</div>
    <div class="col-5">
      <div class="btn-group float-end">
        <button
          type="button"
          class="btn btn-sm btn-success waves-effect"
          @click="prevPage"
          :disabled="currentPage === 1"
        >
          <i class="fa fa-chevron-left"></i>
        </button>
        <button
          type="button"
          class="btn btn-sm btn-success waves-effect"
          @click="nextPage"
          :disabled="currentPage === totalPages"
        >
          <i class="fa fa-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import AppButtonDeleteConfirm from "@/components/AppButtonDeleteConfirm/AppButtonDeleteConfirm.vue";
import AppAvatarAdmin from "@/components/AppAvatarAdmin/AppAvatarAdmin.vue";
import { mapActions } from "vuex";
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  components: {
    AppButtonDeleteConfirm,
    AppAvatarAdmin
  },
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 10,
      searchQuery: ""
    };
  },
  computed: {
    filteredItems() {
      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        return this.items.filter(
          item =>
            item.name.toLowerCase().includes(query) ||
            item.users
              .toString()
              .toLowerCase()
              .includes(query)
        );
      }
      return this.items; // Garantir sempre que retorna um array
    },
    totalPages() {
      return Math.ceil(this.filteredItems.length / this.itemsPerPage);
    },
    paginatedFilteredItems() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredItems.slice(start, end); // Assegure que filteredItems é um array
    },
    total() {
      return Object.keys(this.items).length;
    }
  },
  watch: {
    searchQuery() {
      this.currentPage = 1; // Redefine para a primeira página quando o filtro é alterado
    }
  },
  methods: {
    ...mapActions([
      "showMessage",
      "showLoader",
      "setLoaderTitle",
      "showBlockScreen"
    ]),
    onHandleEdit(id) {
      this.$emit("handle", id);
    },
    onHandleDelete(id) {
      this.$emit("handle2", id);
      const _this = this;
      let headers = _this.$getAPIHeaders("DELETE", `team/${id}`);
      this.axios(headers)
        .then(function(response) {
          console.log("response.data.message");
          _this.showMessage({
            title: response.data.message,
            css: "bg-success"
          });
        })
        .catch(function(error) {
          _this.showMessage({
            title: error.response.data.message,
            text: _this.$root.$options.filters.objectError(
              error.response.data.errors
            ),
            css: "bg-danger"
          });
        });
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    removerItemPorId(id) {
      const index = this.items.findIndex(item => item.id === id);
      if (index !== -1) {
        this.items.splice(index, 1);
        console.log("removido");
      }
    }
  }
};
</script>
<style scoped>
.avatar-xs {
  display: inline-block;
}
.form-control-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.765625rem;
  line-height: 1.5;
}
</style>